var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"videoPlayer",staticClass:"fp-slim is-splash",style:(_vm.posterImg),attrs:{"id":"player"}})}
var staticRenderFns = []

export { render, staticRenderFns }